import { NextRadioStationAsync } from "source/app/services/Sound/Radio/RadioStations";
import SoundManager from "source/app/services/Sound/SoundManager";
import { ToggleGarbleAnimation } from "../Garble/Garble";
import { IKeyboardEvent, TKeyboardEvent } from "./IKeyboardEvents";
import Music from "../../Sound/Music/Music";
import { Sounds } from "../../Sound/Sounds";
import Ambience from "../../Sound/Ambience/Ambience";

const ToggleGarble: IKeyboardEvent = {
    hotkeyDescription: `Ctrl + F9`,
    actionDescription: `Toggle Garble Effect`,
    trigger: (event: TKeyboardEvent) => event.ctrlKey && event.keyCode == 120,
    action: () => ToggleGarbleAnimation(),
};

const ShuffleEnvironment: IKeyboardEvent = {
    hotkeyDescription: `Ctrl + F10`,
    actionDescription: `Shuffle Environment`,
    trigger: (event: TKeyboardEvent) => event.ctrlKey && event.keyCode == 121,
    action: async () => await SoundManager.ShuffleEnvironment(),
};

const ChangeAmbience: IKeyboardEvent = {
    hotkeyDescription: `Ctrl + F11`,
    actionDescription: `Change ambience`,
    trigger: (event: TKeyboardEvent) => event.ctrlKey && event.keyCode == 122,
    action: async () => {
        Sounds.electronic_tone_soft.Play();
        Ambience.Stop();
        Ambience.StartNextAmbience();
    },
};

const ChangeSong: IKeyboardEvent = {
    hotkeyDescription: `Ctrl + F12`,
    actionDescription: `Change song`,
    trigger: (event: TKeyboardEvent) => event.ctrlKey && event.keyCode == 123,
    action: async () => {
        Sounds.electronic_tone_soft.Play();
        Music.ChangeSong();
    },
};

export const desktopKeyboardEvents: IKeyboardEvent[] = [
    ToggleGarble,
    ShuffleEnvironment,
    ChangeAmbience,
    ChangeSong,
];
